module.exports = indentLines;
var eol = /\r?\n|\r/g;
function indentLines(value, map) {
  var result = [];
  var start = 0;
  var line = 0;
  var match;
  while (match = eol.exec(value)) {
    one(value.slice(start, match.index));
    result.push(match[0]);
    start = match.index + match[0].length;
    line++;
  }
  one(value.slice(start));
  return result.join('');
  function one(value) {
    result.push(map(value, line, !value));
  }
}